import { useColorScheme } from 'react-native';

export const useThemeColors = () => {
    const scheme = useColorScheme(); // 'dark' or 'light'

    return {
        text: scheme === 'dark' ? '#2e2e2e' : '#2e2e2e',
        // text: scheme === 'dark' ? '#FFFFFF' : '#000000',
        //  background: scheme === 'dark' ? '#121212' : '#FFFFFF',
        //  placeholder: scheme === 'dark' ? '#AAAAAA' : '#555555',
        placeholder: scheme === 'dark' ? '#AAAAAA' : '#AAAAAA',
        // inputBackground: scheme === 'dark' ? '#1E1E1E' : '#F8F8F8',
    };
};
